/* ToolbarSection.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./ToolbarSection.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
var styles = {
  container: "_zulp1b66 _1e0c1txw _4cvr1h6o"
};
var separator = null;
export var ToolbarSection = function ToolbarSection(_ref) {
  var children = _ref.children,
    testId = _ref.testId,
    hasSeparator = _ref.hasSeparator;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: cx(styles.container),
    testId: testId,
    "data-toolbar-component": "section"
  }, hasSeparator && /*#__PURE__*/React.createElement("div", {
    className: ax(["_195gu2gc _4t3igktf _1bsbt94y _bfhkmuej"])
  }), children);
};